module.exports = __webpack_public_path__ + "img/back-button_superlive.0e343d5a.svg";